



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Game, GameOptions } from '@/game/index';
import { Player } from '@/game/player';
import { Vec2 } from '@/game/vector';
import Field from '@/views/Field.vue';
import Options from '@/views/Options.vue';
import Ranking from '@/views/Ranking.vue';

@Component({
  components: {
    field: Field,
    options: Options,
    ranking: Ranking,
  },
})
export default class SinglePlayer extends Vue {

  public game: Game | null = null;

  public balls: any[] = [];
  public players: Player[] = [];
  public viewPlayers!: Player[];

  constructor() {
    super();
  }

  public created() {
    console.log(this.$route);
    // TODO remove event listeners
    document.addEventListener('keydown', (ev) => {
      this.viewPlayers && this.viewPlayers.forEach(p => {
        switch (ev.key) {
          case p.keys.left: p.setDirection('left'); break;
          case p.keys.right: p.setDirection('right'); break;
        }
      });
    });
    document.addEventListener('keyup', (ev) => {
      this.viewPlayers && this.viewPlayers.forEach(p => {
        switch (ev.key) {
          case p.keys.left:
          case p.keys.right:
            p.setDirection('stop'); break;
        }
      });
    });

    if (this.$route.name === 'single-player-play') {
      let options = localStorage.getItem('game.options');
      if (options) { this.start(JSON.parse(options)); }
      else { this.$router.push('/'); }
    }
  }

  public destroyed() {
    this.stop();
  }

  public start(options: GameOptions) {
    console.log('start game', options);
    this.$router.replace('/play');
    this.game = new Game(options);
    // this.game.addBot();
    this.game.start();
    this.viewPlayers = this.game.getPlayers();

    this.game.subscribe((players: Player[], balls: any[]) => {
      // console.log(JSON.stringify(balls[0]));
      this.players = players;
      this.balls = balls;
    });
  }

  public stop() {
    if (this.game instanceof Game) {
      console.log('stop game');
      this.$router.replace('/');
      this.game.stop();
      this.game = null;
    }
  }
}
